import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "../../../shared/_guards/auth.guard";
import { UnauthGuard } from "../../../shared/_guards/anonymous-auth.guard";
import { signedInGuard } from "./auth/_guards/signed-in.guard";

export const routes: Routes = [
    {
        path: "sign-in",
        loadChildren: () => import("./auth/auth.module").then((m) => m.AuthModule),
        canActivate: [UnauthGuard],
    },
    {
        path: "telegram",
        loadChildren: () => import("./telegram/telegram.module").then((m) => m.TelegramModule),
        canActivate: [UnauthGuard],
    },
    {
        path: "signed-in/:nonce",
        canActivate: [signedInGuard],
        children: [],
    },
    {
        // No guard: it decides itself between the sign-in and the hand-off to the dashboard.
        path: "admin",
        loadComponent: () =>
            import("./auth/admin-handoff/admin-handoff.component").then((m) => m.AdminHandoffComponent),
        data: { title: "Admin" },
    },
    {
        path: "",
        loadChildren: () => import("./user-area/user-area.module").then((m) => m.UserAreaModule),
        canActivate: [AuthGuard],
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule],
})
export class AppRoutingModule {}
